import styled from 'styled-components';

export const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 1.2rem;
  white-space: nowrap;

  .dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  /* Zaplanowane (Live Draft) oraz Start ... (Circular Draft z zaplanowaną datą) - żółty / amber */
  &.DraftLive .dot,
  &.DraftScheduled .dot {
    background: #f59e0b;
  }

  /* Robocze / Uruchomisz ręcznie (Circular manual Draft) - granat */
  &.DraftManual .dot,
  &.Draft .dot {
    background: #1e3a8a;
  }

  /* Trwa / W toku (InProgress) - zielony */
  &.InProgress .dot {
    background: var(--successColor, #07bc0c);
  }

  /* Generowanie raportów (FinishRequested) - żółty/pomarańczowy */
  &.FinishRequested .dot {
    background: var(--waringColor, #fdd078);
  }

  /* Zakończone (Finished) - szary */
  &.Finished .dot {
    background: var(--fontMutedColor, #888888);
  }

  &.DraftLive,
  &.DraftManual,
  &.DraftScheduled,
  &.Draft,
  &.Finished,
  &.FinishRequested {
    color: var(--fontMutedColor, #888888);
  }

  &.InProgress {
    color: var(--fontColor, #363636);
    font-weight: 500;
  }

  .date {
    color: var(--fontMutedColor, #888888);
    font-weight: 400;
  }
`;
